import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import store from '@/store'

Vue.use(Router)

const router = new Router({
	base: process.env.BASE_URL,
	// mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			redirect: '/dashboard',
			component: AppLayout,
			meta: { authRequired: true, hidden: true },
			children: [
				{
					path: '/reports',
					meta: {
						title: 'Reports',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard' },
							{ name: 'Reports', link: 'no' },
						],
					},
					component: () => import('./views/reports'),
				},
				{
					path: '/dashboard',
					meta: {
						title: 'Home',
						breadcrumb: [
							{ name: 'Home', link: 'no', first: true },
						],
					},
					component: () => import('./views/dashboard'),
				},
				{
					path: '/account',
					meta: {
						title: 'Accounts',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Accounts', link: 'no' },
						],
					},
					component: () => import('./views/account'),
				},
				{
					path: '/trending',
					meta: {
						title: 'Trending',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Trending', link: 'no' },
						],
					},
					component: () => import('./views/trending'),
				},
				{
					path: '/evolution',
					meta: {
						title: 'Evolution',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Evolution', link: 'no' },
						],
					},
					component: () => import('./views/evolution'),
				},

				{
					path: '/profile',
					meta: {
						title: 'Profile',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Profile', link: 'no' },
						],
					},
					component: () => import('./views/user'),
				},
				{
					path: '/setting',
					meta: {
						title: 'User Profile Settings',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Organization and Categories', link: 'no' },
						],
					},
					component: () => import('./views/setting'),
				},
				{
					path: '/account/:accountId(\\d+)/profiles',
					meta: {
						title: 'Account Profiles',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Accounts', link: '/account' },
							{ name: 'Profile', link: 'no' },
						],
					},
					component: () => import('./views/profile'),
				},

				{
					path: '/account/:accountId(\\d+)/profiles/:profileId(\\d+)/posts',
					meta: {
						title: 'Profile Posts',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Accounts', link: '/account' },
							{ name: 'Account Profiles', link: '/account/:accountId(\\d+)/profiles' },
							{ name: 'Profile Posts', link: 'no' },
						],
					},
					component: () => import('./views/detail'),
				},
				{
					path: '/post/:postId(\\d+)',
					meta: {
						title: 'Post',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Post', link: 'no' },
						],
					},
					component: () => import('./views/post'),
				},

				{
					path: '/setting',
					meta: {
						title: 'Setting',
						breadcrumb: [
							{ name: 'Home', link: '/dashboard', first: true },
							{ name: 'Setting', link: 'no' },
						],
					},
					component: () => import('./views/setting'),
				},

				// 404
				{
					path: '/404',
					meta: {
						title: 'Error 404',
					},
					component: () => import('./views/system/404'),
				},
			],
		},

		// System Pages
		{
			path: '/auth',
			component: AuthLayout,
			redirect: 'auth/login',
			children: [
				{
					path: '/auth/login',
					meta: {
						title: 'Login',
					},
					component: () => import('./views/system/login'),
				},
				{
					path: '/auth/forgot-password',
					meta: {
						title: 'Forgot Password',
					},
					component: () => import('./views/system/forgot-password'),
				},
				{
					path: '/auth/register',
					meta: {
						title: 'Register',
					},
					component: () => import('./views/system/register'),
				},
				{
					path: '/auth/lockscreen',
					meta: {
						title: 'Lockscreen',
					},
					component: () => import('./views/system/lockscreen'),
				},
				{
					path: '/auth/404',
					meta: {
						title: 'Error 404',
					},
					component: () => import('./views/system/404'),
				},
				{
					path: '/auth/500',
					meta: {
						title: 'Error 500',
					},
					component: () => import('./views/system/500'),
				},
			],
		},

		// Redirect to 404
		{
			path: '*',
			redirect: '/404',
			hidden: true,
		},
	],
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.authRequired)) {
		if (!store.state.user.user) {
			next({
				path: '/auth/login',
				query: { redirect: to.fullPath },
			})
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
